import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import moment from 'moment';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
.opt-area {
  width: 100%;
  display: flex;
}
.opt-area .btn {
  height: auto;
  font: normal normal normal 16px Montserrat;
}
.opt-area .btn-opt {
  padding: 12px 30px;
  width: 50%;
  color: #5D5D5D;
  background: #D7DBE2;
}
.opt-area .btn-opt:hover {
  color: #5263FF;
}
.opt-area .btn-opt.active {
  background-color: white;
  border: none;
  color: black;
}

.map-container {
  display: flex;
  width: 100%;
  height: 100%;
  padding: 24px 0px;
  background: var(--wc-background);
  border-radius: 24px;
  max-width: 1800px;
  margin: 0 auto;
  overflow-y: auto;
}

.widget-area {
  width: 53%;
  max-width: 888px;
  padding-left: 24px;
  height: 100%;
}
@media (max-width: 1024px) {
  .widget-area {
    padding-left: 16px;
  }
}
@media (max-width: 768px) {
  .widget-area {
    padding-left: 8px;
  }
  .widget-area .opt-area {
    flex-direction: column;
    align-items: flex-start;
    height: 3.75rem;
  }
  .widget-area .btn-opt {
    width: 100%;
    margin-bottom: 8px;
    padding: 8px;
  }
}
@media (max-width: 480px) {
  .widget-area .opt-area .btn-opt {
    font-size: 14px;
    padding: 8px 16px;
  }
}

.card {
  margin-bottom: 24px;
  width: 100%;
  box-sizing: border-box;
}
.card .card-header {
  padding: 8px 16px;
}
.card .card-body {
  padding: 12px 24px;
  border-top: none !important;
}
@media (max-width: 768px) {
  .card {
    margin-bottom: 16px;
  }
  .card .card-body {
    padding: 8px 12px;
  }
}
@media (max-width: 480px) {
  .card .card-body {
    padding: 8px 8px;
  }
}

.map-area {
  height: 52rem;
  width: 51%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--wc-background-dark);
  padding: 24px;
  border-radius: 24px;
  overflow: auto;
}
.map-area .map {
  flex: auto;
  width: 100%;
  height: 100%;
}

.input-icon .form-control.form-control-rounded {
  border: 1px solid var(--wc-blue);
  border-radius: 8px;
}
.input-icon .input-icon-addon {
  color: var(--wc-blue);
}

.table-last {
  margin: 0 auto;
  width: 90%;
  margin-top: 1rem;
}
.table-last thead {
  text-align: left;
  font: normal normal bold 14px/16px NanumSquareOTF;
  background: #F6F7FB;
  color: #727272;
  height: 30px;
}
.table-last thead th {
  font: normal normal bold 14px/16px NanumSquareOTF;
}
.table-last tbody tr {
  border-bottom: solid 0.5px #D1D1D1;
  font: normal normal normal 16px/18px NanumSquareOTF;
}
.table-last tbody tr td {
  margin: auto;
  vertical-align: middle;
  padding: 0.5rem 0rem;
  text-align: left;
}

.progress {
  height: 16px;
  border-radius: 8px;
}`],
})
export class PageDashboardComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( Title)  private title: Title) { }

    public traffic: any = null;
    public trafficName = "대전";
    public traffic_status: any = 'ing'
    public items: any = [];
    public node = [];
    public sample = {
        series: [{
            name: 'series1',
            data: [31, 40, 28, 51, 42, 109, 100]
        }, {
            name: 'series2',
            data: [11, 32, 45, 32, 34, 52, 41]
        }]
    };

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/authenticate");
        this.title.setTitle('메인 - MY KREONET');
        await this.load();
    }

    public async alert(message: string, status: string = 'error', cancel: any = false, action: string = '확인') {
        return await this.service.alert.show({
            title: "",
            message: message,
            cancel: cancel,
            actionBtn: status,
            action: action,
            status: status
        });
    }

    public tab: string = 'line';

    public async switchTab(tab: string) {
        this.tab = tab;
        await this.service.render();
    }

    public async load() {
        const { code, data } = await wiz.call("search");
        if (code != 200) return;
        let { rows, lastpage } = data;
        this.items = rows;
        this.loaded = true;
        await this.service.render();
    }

    public event: any = {
        data: {},
        selected: async (location) => {
            this.trafficName = location.name;
            this.traffic = null;
            this.traffic_status = 'ing';
            await this.service.render();

            const { code, data } = await wiz.call("loadTraffic", { id: location.id });
            let traffic = data.traffic;
            this.node = data.node;
            await this.service.render();

            if (traffic) {
                for (let i = 0; i < traffic._time.length; i++)
                    traffic._time[i] = (moment(traffic._time[i]).add(9, 'hours')).format("YYYY-MM-DD HH:mm:ss");

                this.traffic = {
                    category: traffic._time,
                    series: [{
                        name: 'IN',
                        data: traffic._in
                    }, {
                        name: 'OUT',
                        data: traffic._out
                    }]
                };
                this.traffic_status = "success";
            } else this.traffic_status = "error";
            await this.service.render();
        }
    };

}

export default PageDashboardComponent;